<ng-container *ngIf="data$ | async as data">
  <div class="banner-container" *ngIf="hasUrl(data)">
    <a
      *ngIf="isExternalLink && isExternalUrlValid"
      [href]="externalUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="banner-link"
    >
      <ng-container *ngTemplateOutlet="bannercontent; context: { data: data }"></ng-container>
    </a>
    <a *ngIf="!isExternalLink && routerLink" [routerLink]="routerLink" class="banner-link">
      <ng-container *ngTemplateOutlet="bannercontent; context: { data: data }"></ng-container>
    </a>
    <div *ngIf="isExternalLink && !isExternalUrlValid" class="error-message">
      <p>Invalid external URL. Please Update a Valid Url</p>
    </div>
  </div>
  <div class="banner-container" *ngIf="!hasUrl(data)">
    <ng-container *ngTemplateOutlet="bannercontent; context: { data: data }"></ng-container>
  </div>
</ng-container>

<ng-template #bannercontent let-data="data">
  <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
  <eb-responsive-media
    [container]="data.media"
    [alt]="data.alt"
    [alignTextLeft]="data.alignTextLeft"
  >
  </eb-responsive-media>

  <div class="banner-inner-container" [ngClass]="data.alignTextLeft == 'true' ? 'left' : 'right'">
    <div class="banner-paragraph-container" *ngIf="data.content">
      <div class="banner-paragraph-content" [innerHTML]="data.content | safeHtml"></div>
    </div>
    <ng-container *ngIf="data.buttonText">
      <button *ngIf="!isExternalLink && routerLink" [routerLink]="routerLink">
        {{ data.buttonText }}
      </button>
      <button *ngIf="isExternalLink" (click)="handleExternalLinkClick(externalUrl, $event)">
        {{ data.buttonText }}
      </button>
    </ng-container>
  </div>
</ng-template>
